export const optionsForSurvey = ({
  aggregate,
  apiVersion,
  oldSurveys = [],
  onlyReturnOldSurveys,
  summaryActions,
  questionName,
  doneOnly,
  currentSurveysOnly
}) => {
  const options = {}
  if (aggregate) {
    options.aggregate = true
  }
  if (apiVersion) {
    options.v = apiVersion
  }
  if (currentSurveysOnly) {
    options.currentSurveysOnly = `${currentSurveysOnly}`
  }
  if (oldSurveys.length) {
    options.oldSurveys = oldSurveys.join(',')
  }
  if (summaryActions) {
    options.summaryActions = summaryActions
  }
  if (onlyReturnOldSurveys) {
    options.onlyReturnOldSurveys = true
  }
  if (questionName) {
    options.questionName = questionName
  }
  if (doneOnly) {
    options.doneOnly = doneOnly
  }
  return {
    queryParams: options
  }
}
